import * as requester from '../utils/requester';

export const createRseePackageRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: 'v1/rsee-package',
        method: 'POST',
        data: reqObject,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const editRseePackageRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: 'v1/rsee-package',
        method: 'PUT',
        data: reqObject,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getRseePackageByIdRequest = packageId => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/rsee-package/${packageId}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getAllRseePackagesRequest = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/rsee-package/?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getRseePackagesSalesReportRequest = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: `v1/rsee-package/sales-report?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const editRseePackageStatusRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: 'v1/rsee-package',
        method: 'PUT',
        data: reqObject,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};